import { useEffect, useState } from "react";
import { supabase } from "../supabase/client";
import type { CampaignQuestion } from "../types/CampaignQuestion";

export function useCampaignQuestions() {
  const [questions, setQuestions] = useState<CampaignQuestion[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchQuestions = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("campaign_questions")
        .select("*")
        .order("created_at", { ascending: true });

      if (error) {
        setError(error);
      } else {
        setQuestions(data as CampaignQuestion[]);
      }

      setLoading(false);
    };

    fetchQuestions();
  }, []);

  return { questions, loading, error };
}
